import type { User } from '~/modules/users/model'

export const presentName = (user: User) => [user.name.firstName ?? '', user.name.lastName ?? ''].join(' ').trim()
export const isProbablyDeleted = (email: string) => email.startsWith('deleted')
